<template>
	<div class="page_container" :class="'p'+this.$route.name">
		<div class="page_hero p">
	  		<div>
	  			<h1>{{this.$route.meta.name}}</h1>
	  			<router-view class="sub_nav fade-in fade-out"></router-view>
	  			<div class="page_about">
  					<p v-html="presentation"></p>
  					<div class="actions">

  						<router-link class="routerlink" to="/etat_civil/carte_identite_passeport">
			  			<div class="action cni">
			  				<div class="title">
			  					<h3>Carte d'identité et passeport</h3>
			  				</div>
			  				<div class="sub">
			  					<button>En savoir plus</button>
			  				</div>
			  			</div>
			  			</router-link>

			  			<router-link class="routerlink" to="/etat_civil/photomaton">
			  			<div class="action photomaton">
			  				<div class="title">
				  				<h3>Photomaton</h3>
				  			</div>
				  			<div class="sub">
				  				<button>En savoir plus</button>
				  			</div>
			  			</div>
			  			</router-link>
			  			
			  		</div>
  				</div>
  			</div>
	  	</div>
	</div>
</template>

<script>
	const fb = require('../firebaseConfig.js')
	import firebase from 'firebase'
export default {
	name: 'Conduite',
			data () {
			return {
				presentation:''
			}
		},
		methods: {
		},
		mounted () {
			if(Object.keys(this.$store.state.static).length === 0){
				firebase.auth().signInAnonymously()
      			.then(() => {
					// console.log("object empty")
					fb.db.collection('documents').doc(this.$route.meta.parent_name).get()
			  		.then(res => {
				  		this.presentation = res.data().presentation
			  		})
			  	})
			}else{
				// console.log("object not very empty my friend for conduite")
				var doc = this.$store.state.static[this.$route.meta.parent_name]
		  		this.presentation = doc.presentation
			}
		}
	}
</script>

<style scoped>

</style>
   


// WEBPACK FOOTER //
// src/components/Etatcivil.vue